import ImageExample from "./examples/Image.Example";
import barsImage from "./examples/bars.png";

export default [
    {
        title: "Basic image",
        component: ImageExample,
        code: require("!raw-loader!./examples/Image.Example.tsx"),
        dependencies: {
            "bars.png": barsImage
        }
    }
];
